import React from 'react';
import PropTypes from 'prop-types';

import { QuillEditor } from 'core/quill';
import styles from '../styles/formFieldTextEditor.module.scss';

const FormFieldTextEditor = ({
  fieldId,
  onEditorChange = () => {},
  onEditorLoad = () => {},
  placeholder = '',
  textEditorOptions = {},
  value = '',
}) => (
  <div className={styles.element}>
    <QuillEditor
      placeholder={placeholder}
      id={fieldId}
      value={value}
      emojiPickerPosition="top"
      shouldAutoFocus={false}
      shouldShowEmojiButton={false}
      shouldAllowUploads={false}
      shouldAllowMentions={false}
      shouldShowSubmitButton={false}
      shouldAllowEmojis
      shouldSubmitOnEnter={false}
      shouldSubmitOnCmdEnter={false}
      onLoad={onEditorLoad}
      onChange={onEditorChange}
      hasToolbar={false}
      {...textEditorOptions}
    />
  </div>
);

FormFieldTextEditor.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onEditorLoad: PropTypes.func,
  onEditorChange: PropTypes.func,
  fieldId: PropTypes.string.isRequired,
  textEditorOptions: PropTypes.object,
};

export default React.memo(FormFieldTextEditor);
